import { createSignal } from "solid-js";
export const [loaded, setLoaded] = createSignal();
